<template>
  <div>
    <template v-if="showMain">
      <Main :baseUrl="baseUrl" />
    </template>
    <template v-else>
      <Album :baseUrl="baseUrl" :albumUrl="albumUrl" />
    </template>
  </div>
</template>

<script>
import Album from "./website/Album.vue";
import Main from "./website/Main.vue";
import { getReqParams, isNullOrEmpty, normalizeUrl, startsWith } from "./website/Utils.js";

export default {
  name: "App",
  components: {
    Album,
    Main,
  },
  data() {
    return { showMain: true, baseUrl: "", albumUrl: "" };
  },
  created() {
    var ref = window.location.href;
    var list = ref.split("/");
    var protocol = list[0];
    var host = list[2];
    this.baseUrl = protocol + "//" + host;

    var params = getReqParams();
    var urlParam = params["url"];

    var p;
    if (!isNullOrEmpty(urlParam)) {
      p = urlParam;
    } else if (list.length >= 5) {
      p = '/' + list[3] + "/" + list[4];
    } 
    p = normalizeUrl( p );

    if( p ) {
      if( !startsWith(p, '/albums/') ) {
        p = '/albums' + p;
      }
      this.albumUrl = p;
      this.showMain = false;
    } else {
      this.showMain = true;
    }

    console.log( this.baseUrl + ' --> ' + this.albumUrl );

  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
